export default "__VITE_ASSET__6b9242cc__"